import { FC } from 'react';
import styled from 'styled-components';
import { AUD_INSIGHTS_GRID_COL_COUNT } from './constants';

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(${AUD_INSIGHTS_GRID_COL_COUNT}, 1fr);
  column-gap: ${({ theme }) => theme.spacing.values.plusHalf};
  flex-grow: 1;
`;

export const Grid: FC<React.PropsWithChildren<unknown>> = ({ children }) => (
  <Wrapper data-test="audience-insights-drawer">{children}</Wrapper>
);
